import { render } from "./App.vue?vue&type=template&id=eab6dc0a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=eab6dc0a&lang=css"

import exportComponent from "C:\\Users\\Esther Ibom\\Desktop\\vue-exam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__